export const dialogContentSx = {
  p: '16px !important',
  bgcolor: '#FFFFFF',
  overflow: 'hidden'
};

export const tablePaperSx = {
  height: 420,
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
  borderColor: '#E0E0E0',
  borderRadius: '8px',
  boxShadow: 'none'
};

export const tableContainerSx = {
  flex: 1,
  minHeight: 0,
  overflowY: 'auto',
  overflowX: 'auto',

  '&::-webkit-scrollbar': {
    display: 'none'
  },

  scrollbarWidth: 'none',
  msOverflowStyle: 'none'
};

export const tableSx = {
  minWidth: 750,
  tableLayout: 'fixed'
};

export const tableBodyCellSx = {
  px: 1.5,
  py: 0,
  height: 38,
  color: '#424242',
  fontSize: 12,
  fontWeight: 400,
  borderBottom: '1px solid #EEEEEE',
  whiteSpace: 'nowrap'
};

export const actionCellSx = {
  px: 1,
  py: 0,
  height: 38,
  borderBottom: '1px solid #EEEEEE'
};

export const copyButtonSx = {
  p: 0.5,
  color: '#757575',

  '&:hover': {
    color: '#1976D2',
    bgcolor: 'transparent'
  }
};

export const emptyCellSx = {
  py: 4,
  borderBottom: 0
};

export const emptyTextSx = {
  color: '#757575',
  fontSize: 13
};

export const dialogActionsSx = {
  px: 2,
  py: 2.25,
  bgcolor: '#FFFFFF',
  borderTop: '1px solid #D9D9D9'
};

export const closeButtonSx = {
  bgcolor: '#5897D4',
  color: '#FFFFFF',
  borderRadius: '4px',
  boxShadow: 'none',
  fontSize: 12,
  fontWeight: 500,
  textTransform: 'uppercase',

  '&:hover': {
    bgcolor: '#4B89C5',
    boxShadow: 'none'
  }
};